<template>
  <a-page-header
    :ghost="false"
    :breadcrumb="{ props: { routes, itemRender } }"
    :title="title"
    :class="{ pb0: $route.meta.extraCenter }"
  >
    <!-- <h1 v-if="$route.meta.extra">
      <img :src="logoUrl" width="70" class="logo-img" />
      <span class="welcome-text">
        您好！{{ $store.getters['user/username'] }} 欢迎登录{{
          $store.getters['app/sysName']
        }}
      </span>
    </h1> -->
    <CompanyMessage v-if="$route.meta.extraCenter" />
  </a-page-header>
</template>

<script>
import { mapGetters } from 'vuex'
import CompanyMessage from 'views/client/client-center/components/CompanyMessage'

export default {
  data() {
    return {
      routes: [],
      title: '',
      itemRender({ route, h }) {
        return h('span', { key: `${Math.random()}` }, route.breadcrumbName)
      },
    }
  },
  components: { CompanyMessage },
  computed: {
    ...mapGetters('user', ['menuUrlName']),
    ...mapGetters('app', ['logoUrl']),
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        const { title } = this.$route.meta
        this.routes = [
          {
            path: '/',
            breadcrumbName: '主页',
          },
          ...this.menuUrlName,
        ]
        this.title =
          title || this.menuUrlName[this.menuUrlName.length - 1].breadcrumbName
      },
    },
  },
}
</script>

<style lang="less" scoped>
.welcome-text {
  margin-left: 20px;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.85);
}
.pb0 {
  padding-bottom: 0;
}
</style>
